import fetchRequest from '../../helpers/fetchRequest';

export async function createBlock(data) {
  const url = '/about';
  const options = {
    method: 'POST',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
  };
  return fetchRequest(url, options);
}

export async function getBlocksForTable() {
  const url = '/about';
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  return fetchRequest(url, options);
}

export async function getBlockById(id) {
  const url = `/about/${id}`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  return fetchRequest(url, options);
}

export async function updateBlockById(data) {
  const url = `/about/${data.id}`;
  const options = {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
  };
  return fetchRequest(url, options);
}

export async function deleteBlockById(id) {
  const url = `/about/${id}`;
  const options = {
    method: 'DELETE',
  };
  return fetchRequest(url, options);
}
